/**
 * Shared cookie-consent preference cookie for B2C (and Discover on the same domain).
 * Name: cookieControlPrefs_{culture} (culture = CodeForUrl, e.g. us / global)
 * Path: /; Expires: 30 days; Secure (HTTPS); SameSite=Lax
 */
(function (w) {
    "use strict";

    var LEGACY_NAME = "cookieControlPrefs";
    var EXPIRES_DAYS = 30;
    var ACCEPT_ALL = '["essential","statistics","marketing"]';

    function cultureCode() {
        if (w.culture && String(w.culture)) {
            return String(w.culture);
        }
        // Fallback when this script runs before _CommonJavascriptParameters
        try {
            var match = w.location && w.location.pathname && w.location.pathname.match(/^\/([^\/\?]+)/);
            return match ? match[1] : "";
        } catch (ex) {
            return "";
        }
    }

    function cookieName(culture) {
        var c = culture != null && culture !== "" ? String(culture) : cultureCode();
        return "cookieControlPrefs_" + c;
    }

    function readRaw(name) {
        if (!name) {
            return null;
        }
        var ca = document.cookie.split(";");
        var prefix = name + "=";
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(prefix) === 0) {
                try {
                    return decodeURIComponent(c.substring(prefix.length));
                } catch (ex) {
                    return c.substring(prefix.length);
                }
            }
        }
        return null;
    }

    function expire(name, path) {
        if (!name) {
            return;
        }
        var cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + (path || "/") + ";SameSite=Lax";
        if (w.location && w.location.protocol === "https:") {
            cookie += ";Secure";
        }
        document.cookie = cookie;
    }

    function set(value, options) {
        options = options || {};
        var days = options.expires != null ? options.expires : EXPIRES_DAYS;
        var name = options.name || cookieName(options.culture);
        var d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        var cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
        if (w.location && w.location.protocol === "https:") {
            cookie += ";Secure";
        }
        document.cookie = cookie;
        return readRaw(name);
    }

    function get(culture) {
        return readRaw(cookieName(culture));
    }

    function has(culture) {
        return get(culture) != null;
    }

    /**
     * If the new path=/ cookie is missing but the old path=/{culture} cookie exists,
     * copy to the new cookie and expire the old one.
     */
    function migrate() {
        var c = cultureCode();
        if (!c) {
            return false;
        }
        var newName = cookieName(c);
        if (readRaw(newName)) {
            return false;
        }
        var legacy = readRaw(LEGACY_NAME);
        if (!legacy) {
            return false;
        }
        set(legacy, { name: newName });
        expire(LEGACY_NAME, "/" + c);
        return true;
    }

    function acceptAll() {
        return set(ACCEPT_ALL);
    }

    w.CookieConsentPrefs = {
        legacyName: LEGACY_NAME,
        expiresDays: EXPIRES_DAYS,
        acceptAllValue: ACCEPT_ALL,
        name: cookieName,
        get: get,
        set: set,
        expire: expire,
        migrate: migrate,
        has: has,
        acceptAll: acceptAll
    };

    // Migrate as early as possible when culture is already available
    try {
        migrate();
    } catch (ex) { /* ignore */ }
})(typeof window !== "undefined" ? window : this);
